import React from 'react';

import { CircularProgress } from '@mui/material';

import { TableCell, TableRow } from '../../ui';
import { IInfiniteScrollIndicatorProps } from '../DataTable.types';

export const InfiniteScrollIndicator: React.FC<IInfiniteScrollIndicatorProps> =
  ({ columnsCount, loadMoreRef, isLoadingMore, hasMore, enabled }) => {
    if (!enabled) {
      return null;
    }

    if (isLoadingMore) {
      return (
        <TableRow>
          <TableCell colSpan={columnsCount} className="text-center py-4 border-t">
            <CircularProgress size={24} />
          </TableCell>
        </TableRow>
      );
    }

    if (hasMore) {
      return (
        <TableRow>
          <TableCell colSpan={columnsCount} className="text-center py-2 border-t">
            <div
              ref={loadMoreRef}
              style={{ height: '1px', visibility: 'hidden' }}
            />
          </TableCell>
        </TableRow>
      );
    }

    return null;
  };
